// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama()
import "../../sass/main.scss";
import { AnimateVideoSlider } from "../components/AnimateSliderVideo";
import { bgColors } from "../components/bgColors";
import { BorderAnimate } from "../components/BorderAnimate";
// import { internaExperiencias } from "../pages/experienciaInterna";
import { encoder } from "../services/encoder";

declare global {
  interface Window {
    dataLayer: any;
    CryptoJS: any;
    getUserTapit(): any;
  }
}

// const api = new apiDrupal();
window.addEventListener("load", () => {
  console.log("loaddd!!!zz");
  duplicateLastStep();
  assignClassToForm();
  hideErrorMessage();
  /* ON LOAD */
  AnimateVideoSlider();
  headerGeneral();
  bgColors();
  // internaExperiencias();
  retornarSO();
  loginAdmin();
});

const headerGeneral = () => {
  let isActive = document.querySelector(".is-active") as HTMLElement;
  if (isActive) {
    let hrComponent = document.createElement('hr');
    isActive.appendChild(hrComponent);
  }
  setTimeout(function () {
    let nameUser = document.querySelectorAll("#logoutTapit") as any;
    if (nameUser) {
      nameUser.forEach(function (e: any) {
        if (e.innerHTML.length > 5) {
          e.textContent = e.textContent.substr(0, 7)+"..";
        }
        e.classList.add("visbleName");
      });
    }
  }, 2000);
};

let navInfo = window.navigator.appVersion.toLowerCase();
function retornarSO() {
  if (navInfo.includes("iphone")) {
    let video = document.querySelector(".container-video iframe") as any;
    if (video) {
      video.classList.add("iphone");
    }
  }
}

const loginAdmin = () => {
  let pathname = window.location.pathname;
  if (pathname == "/user/login" || pathname == "/user/password") {
    let container = document.querySelector(".main-container div") as any;
    container.classList.add("loginAdmin");
  }

  if (pathname != "/") {
    BorderAnimate();
  }
  if (pathname != "/productos-bbc") {
    BorderAnimate();
  }
  if (pathname == "/gracias-por-registrarte") {
    let container = document.querySelector(".main-container") as any;
    container?.classList.add("thanksPage");
  }
};

function duplicateLastStep() {
  console.log("duplicate");

  const lastStep = document.querySelector(
    ".register-wifi-bbc form .webform-progress ul li.progress-step:last-child"
  );

  if (lastStep !== null) {
    const clonedStep = lastStep.cloneNode(true);
    const parent = document.querySelector(
      ".register-wifi-bbc form .webform-progress ul"
    );

    if (parent !== null) {
      parent.prepend(clonedStep);
    }
  }
}

function assignClassToForm() {
  console.log("bg blue");
  const prevButton = document.querySelector("input#edit-actions-wizard-prev");
  const prevButton2 = document.querySelector("input#edit-wizard-prev");
  const form = document.querySelector(".register-wifi-bbc");
  if (
    (prevButton !== null && form !== null) ||
    (prevButton2 !== null && form !== null)
  ) {
    form.classList.add("bgBlue");
  } else if (form !== null) {
    form.classList.remove("bgBlue");
  }
}

function hideErrorMessage() {
  const errorMessage = document.querySelector(
    '[aria-label="Error message"]'
  ) as HTMLElement;
  if (errorMessage) {
    errorMessage.style.display = "none";
  }
}

function dataLayers() {
  console.log("adasda");

  const btn_register_bbcwifi = document.querySelectorAll(
    "#onboardRegister"
  ) as any;
  // DL Btn Register form BBC-WiFi
  btn_register_bbcwifi.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "on_boarding_start",
        component_type: "On Boarding",
        component_name: "on_boarding_btn_start",
        message_response: "On Boarding Start",
        element_text: document.querySelector("#onboardRegister")?.textContent,
      });
    });
  });

  // DL Link Ya estoy registrado
  const btn_registred_bbcwifi = document.querySelectorAll(
    ".onboard__cont--registred"
  ) as any;
  btn_registred_bbcwifi.forEach((element: any) => {
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "on_boarding_registered",
        component_type: "On Boarding",
        component_name: "on_boarding_btn_registered",
        message_response: "On Boarding Registered",
        element_text: document.querySelector(".onboard__cont--registred")
          ?.textContent,
      });
    });
  });

  // DL Btn BBC-WiFi Usuario ya registrado
  const btn__emailregistred = document.querySelector(
    "[data-drupal-selector='edit-wizard-next']"
  ) as any;
  if (btn__emailregistred) {
    btn__emailregistred.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "user_validation_form_submit",
        component_type: "User Validation Form",
        component_name: "user_validation_btn_submit",
        message_response: "User Validation Form Submit",
        element_text: btn__emailregistred?.getAttribute("value"),
      });
    });
  }

  // DL Btn BBC-WiFi Usuario ya registrado
  const btn__registredquestion = document.querySelector(
    "[datadata-drupal-selector='edit-submit']"
  ) as any;
  const question1 = document.querySelector(
    ".js-form-item-pregunta-1 label"
  )?.textContent;
  if (btn__registredquestion) {
    btn__registredquestion.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "GAEvent",
        event_name: "data_enrichment_form_submit",
        component_type: "Data Enrichment Form'",
        component_name: "data_form_btn_submit",
        message_response: "Data Enrichment Form Submit",
        element_text: btn__registredquestion?.getAttribute("value"),
        question: question1,
        answer: "asddadad",
      });
    });
  }

  // DL Btn BBC-WiFi Usuario no registrado
  const btn__unregistred = document.getElementById("unregisted") as any;
  btn__unregistred.addEventListener("click", (e: any) => {
    console.log("btn__unregistred", btn__unregistred);
    window.dataLayer.push({
      event: "GAEvent",
      event_name: "unregistered_action",
      component_type: "Unregistered",
      component_name: "unregistered_btn_start",
      message_response: "Sign Up Start'",
      element_text: btn__unregistred?.textContent,
    });
  });

  // DL Thank You Page BBC-WiFi
  const btn__navigate = document.querySelector("#startTest") as any;
  let title = btn__navigate.getAttribute("value");
  btn__navigate.addEventListener("click", (e: any) => {
    window.dataLayer.push({
      event: "GAEvent",
      event_name: "wifi_conected_action",
      component_type: "Wifi Status Page",
      component_name: "wifi_connected_btn_ready",
      message_response: "Ok",
    });
  });

  // DL Expired Page
  const btn__reconect_expired = document.querySelector("#reconect") as any;
  btn__reconect_expired.addEventListener("click", (e: any) => {
    window.dataLayer.push({
      event: "GAEvent",
      event_name: "wifi_connection_expired",
      component_type: "Wifi Status Page",
      message_response: "Wifi Expired",
    });
  });

  /* ****************************************  */

  // Old DLs
  const btn_letter = document.querySelectorAll(
    ".btn_establishment_letter"
  ) as any;
  btn_letter.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "BBC", // Categoría del evento (String). Requerido.
        eventAction: "Ver Carta", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: title, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });

  const btn_most_awarded = document.querySelectorAll(
    ".btn_most_awarded"
  ) as any;
  btn_most_awarded.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "BBC", // Categoría del evento (String). Requerido.
        eventAction: "Ir a la tienda", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: title, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });

  const btn_experience = document.querySelectorAll(
    ".btn_plus_experience"
  ) as any;
  btn_experience.forEach((element: any) => {
    let title = element.getAttribute("data-title");
    element.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        event: "trackEvent",
        eventCategory: "BBC", // Categoría del evento (String). Requerido.
        eventAction: "Experiencias", // Acción o subcategoría del evento (String). Requerido.
        eventLabel: title, // Etiqueta de descripción del evento (String). Requerido.
      });
    });
  });

  window.CryptoJS = new encoder();
  document.addEventListener("tapitLoad", async (e: any) => {
    // Enviar datalayer
    const { user, isLogout, userNullTapit, newUser } = e.detail;
    const userAwaitTapit = await window.getUserTapit();
    window.dataLayer = window.dataLayer || [];
    if (newUser === true) {
      //Registro
      window.dataLayer.push({
        event: "Record",
        page: "bbccerveceria.com",
        medium: "Tapit",
        userID: window.CryptoJS.sha256(userAwaitTapit.user.email),
      });
    } else if (newUser === false) {
      //Login
      window.dataLayer.push({
        event: "login",
        medium: "Tapit",
        userID: window.CryptoJS.sha256(userAwaitTapit.user.email),
      });
    }
  });
}
